/**
 * Component Registry for Residences at Prairiefire Apartment Homes
 * 
 * Inherits from @vibesites-price-brothers/theme-vantage and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-vantage/registry';
import { Hero } from './components/Hero';
import { PropertyOverview } from './components/PropertyOverview';
import { FloorplansList } from './components/FloorplansList';
import { NeighborhoodSection } from './components/NeighborhoodSection';
import { ScheduleTourForm } from './components/ScheduleTourForm';
import { ContactForm } from './components/ContactForm';
import { SisterProperties } from './components/SisterProperties';
import { ThankYouContent } from './components/ThankYouContent';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { SitemapContent } from './components/SitemapContent';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Hero,
  PropertyOverview,
  FloorplansList,
  NeighborhoodSection,
  ScheduleTourForm,
  ContactForm,
  SisterProperties,
  ThankYouContent,
  Footer,
  Header,
  SitemapContent,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
